<template>
    <van-popup class="common-pop" v-model:show="show" position="bottom" closeable close-on-popstate round :z-index="3000">
        <div class="pop-title">{{ $t('earncash.earncash_withdraw_title') }}</div>
        <div class="common-content">
            <div class="info">
                <div class="top">
                    <p class="balance" v-html="$t('earncash.earncash_available_2')"></p>
                    <!-- <div class="record" @click="state.recordVisible = true">
                        <IconFont class="left" name="record" />{{ $t('Record') }}<IconFont class="right" name="jiantou" />
                    </div> -->
                </div>
                <div class="withdraw">
                    {{ formatmoney(data.current) }}
                </div>
            </div>
            <div class="content">
                <div class="payout-method">
                    <MethodIcon v-if="isBinded" :paytype="state.accountInfo?.content?.paytype" />
                    <div v-if="isBinded" class="method-card" @click="editBindInfo">
                        <div class="method-card-content">
                            <div class="binded-item" v-for="item in bindedConfig" :key="item.type">
                                <div class="bind-name">{{ $t(item.text) }}:</div>
                                <div class="bind-text">
                                    {{ getShow(item) }}
                                    <!-- <span :class="['icon', { active: !isSecret }]" v-if="item.type === 1" @click="isSecret = !isSecret"></span> -->
                                </div>
                            </div>
                        </div>

                        <div class="edit-btn" @click="editBindInfo"></div>
                    </div>
                    <div v-else class="bind-account" @click="handleBind">
                        <div>{{ isUSDT ? $t('withdrawal.bind_usdt_wallet') : $t('Bind_bank_account') }}</div>
                    </div>
                </div>
                <p class="withdraw-title">{{ $t('Wallet_Withdraw_Amount') }}</p>
                <van-field
                    v-model="state.digit"
                    type="digit"
                    :placeholder="
                        $t('earncash.earncash_withdraw_number', {
                            number1: data.transConfig?.payoutMin,
                            number2: data.transConfig?.payoutMax,
                        })
                    "
                />
                <div v-if="state.digit" class="money-pay">
                    {{ $t('earncash.earncash_available_4') }} =
                    <span class="text-green">{{ data.transConfig?.payoutRate }} </span>
                    × <span class="icon"></span> {{ state.digit }} = {{ store.cureencySymbol() }}{{ outMoney }}
                </div>
                <div
                    v-else
                    class="money-pay"
                    v-html="
                        $t('earncash.earncash_available_3', {
                            number: data.transConfig?.payoutRate,
                        })
                    "
                ></div>
                <p class="tip" v-html="$t(`Wallet_withdr_info_${store.wallet?.currency}`)"></p>
            </div>
            <div
                :class="[
                    'wallet-btn',
                    {
                        disabled: !state.digit,
                    },
                ]"
            >
                <div class="btn" @click="doSubmit">
                    {{
                        $t(
                            'withdraw_button',
                            state.digit
                                ? {
                                      current_type: store.cureencySymbol(),
                                      current_number: outMoney,
                                  }
                                : {}
                        )
                    }}
                </div>
                <!-- <div v-if="payRate" class="pay-tip">
                    {{
                        $t('wallet_withd_fee_info', {
                            number: store.cureencySymbol() + (outMoney - payRate <= 0 ? 0 : outMoney - payRate),
                            number2: store.cureencySymbol() + payRate,
                        })
                    }}
                </div> -->
            </div>
        </div>
        <!-- <Server /> -->
    </van-popup>
    <Record v-if="state.recordVisible" v-model="state.recordVisible" :type="2" source="earncash" :z-index="3001" />
    <Lamp v-if="show && (!state.isAuto || !state.channels.length)" :channel="['1']" tip="wallet_Withdraw_roll" />
    <AccountBind ref="bindCom" v-model="bindVisible" @confirm="bindConfirm" />
</template>
<script setup lang="ts">
import { useBaseStore } from '@/stores'
import * as api from '@/api/wallet'
import { AccountInfo } from '@/api/wallet/type'
import { formatLocalMoney, formatmoney } from '@/utils/toolsValidate'
import Record from '@/components/wallet/record.vue'
import Server from '@/components/server.vue'
import { useI18n } from 'vue-i18n'
import Lamp from '@/components/wallet/walletLamp.vue'
import IconFont from '@/plugins/iconfont/IconFont.vue'
import BindDialog from '../dialog/BindDialog.vue'
import AccountBind from '../wallet/accountBind.vue'
import { convertWithdrawDataToDetail, QueryOrderParamsEvent } from '../transactionDetail/Utils'
import { queryOrderDetails } from '../transactionDetail/service'
const router = useRouter()
const props = defineProps({
    data: {
        type: Object,
        default: () => ({}),
    },
})
const show = defineModel()
const store = useBaseStore()
const i18n = useI18n()

const emit = defineEmits(['exchangeFinish'])
const bindVisible = ref(false)
const bindCom = ref(null)
const isSecret = ref(false)
const payTypeMap = {
    wakapaypapara1: 'Papara',
    pageasy1: 'Pix',
    ngnwakapay1: 'Palmpay',
}

watch(show, () => {
    getAccountInfo()
    console.log('store.wallet.currency', props.data)
})
watch(
    () => store.wallet.currency,
    () => {
        getEarnPayOutInfos()
    }
)

const bindedConfig = computed(() => {
    switch (store.wallet?.currency) {
        case 'USD':
            return [
                // {
                //     text: 'USDT_address',
                //     type: 1,
                //     key: 'phone',
                // },
                {
                    text: 'name',
                    type: 1,
                    key: 'bankNo',
                },
                // {
                //     text: 'USDT_Dig_curr_channel_name',
                //     type: 2,
                //     key: 'paytype',
                // },
            ]
        case 'NGN':
            return [
                {
                    text: 'Account_Name',
                    type: 1,
                    key: 'bankNo',
                },
                // {
                //     text: 'Channel',
                //     type: 2,
                //     key: 'paytype',
                // },
            ]
            return
        case 'BRL':
            return [
                {
                    text: 'Reg_Mob_phone_No',
                    type: 1,
                    key: 'phone',
                },
                // {
                //     text: 'Channel',
                //     type: 2,
                //     key: 'paytype',
                // },
            ]
        case 'TRY':
            return [
                {
                    text: 'Account_Name',
                    type: 1,
                    key: 'bankNo',
                },
                // {
                //     text: 'Channel',
                //     type: 2,
                //     key: 'paytype',
                // },
            ]
        case 'INR':
            return [
                {
                    text: 'Acc No',
                    type: 1,
                    key: 'phone',
                },
                {
                    text: 'IFSC',
                    type: 2,
                    key: 'ifsc',
                },
            ]
        case 'USDT':
            return [
                {
                    text: 'USDT_Blockchain',
                    type: 1,
                    key: 'address',
                },
                {
                    text: 'USDT_address',
                    type: 1,
                    key: 'phone',
                },
            ]
        case 'PHP':
        default:
            return [
                {
                    text: 'Account_Name',
                    type: 1,
                    key: 'phone',
                },
                // {
                //     text: 'Channel',
                //     type: 2,
                //     key: 'paytype',
                // },
            ]
    }
})

const getShow = (item) => {
    const key = item.key
    const content = state.accountInfo?.content
    const payTypeValue = content[content.paytype][key]
    return item.key === 'paytype'
        ? (payTypeMap[payTypeValue] || payTypeValue)?.toUpperCase()
        : payTypeValue?.replace(/.*/g, ($1) => {
              return isSecret.value ? '*'.repeat($1.length) : $1
          })
}

const isUSDT = computed(() => {
    return store.wallet?.currency === 'USDT'
})

const handleBind = () => {
    bindVisible.value = true
}

// 修改账户
const editBindInfo = () => {
    bindCom.value.editAssign(state.accountInfo.content[state.accountInfo.content.paytype])
    bindVisible.value = true
}

const bindConfirm = () => {
    getAccountInfo(false)
    bindVisible.value = false
}

const withDrawConfirm = reactive({
    visible: false,
    num: 0,
})

const state = reactive<{
    accountInfo: AccountInfo
    [key: string]: any
}>({
    accountInfo: {},
    payOutList: [],
    accountIndex: -1,
    showBindPhone: false,
    cantDepose: false,
    conditon: {},
    recordVisible: false,
    digit: '',
    isAuto: true,
    channels: [],
})
const payType = ref('')
const payRate = computed(() => {
    if (!state.digit) {
        return 0
    }
    return store.getPayoutRate(state.digit, state.conditon.feepercent, state.conditon.fee)
})
const outMoney = computed(() => Math.floor(props.data.transConfig?.payoutRate * state.digit || 0))

const isBinded = computed(() => {
    if (!state.accountInfo?.content?.paytype || !state.accountInfo?.content) {
        return false
    }
    return !!state.accountInfo?.content[state.accountInfo?.content?.paytype]
})
const doSubmit = async () => {
    if (props.data.current < state.digit) {
        return showFailToast(i18n.t('earncash.earncash_withdraw_noenough'))
    }
    if (!state.digit || state.digit < props.data.transConfig.payoutMin || state.digit > props.data.transConfig.payoutMax) {
        return showFailToast(
            i18n.t('earncash.earncash_withdraw_wrong_number', {
                number1: props.data.transConfig.payoutMin,
                number2: props.data.transConfig.payoutMax,
            })
        )
    }
    // if (state.accountInfo.bind && !store.userInfo?.telephone) {
    //     return (state.showBindPhone = true)
    // }
    const { state: states, times } = state.accountInfo.balanceTimesInfo
    if (!states || times === 0) {
        return showFailToast(i18n.t('earncash.Withdrawal_times_max_info', { count: times }))
    }

    const res = await store.payOutEarn({
        nickname: store.userInfo.nickname,
        amount: Number(state.digit),
        paytype: state.accountInfo.content.paytype,
    })
    if (res.code === 200) {
        // withDrawConfirm.visible = true
        // withDrawConfirm.num = state.digit
        // 展示提现订单详情
        pollWithdrawDetail(res.orderId)
        emit('exchangeFinish', res.balance)
    } else {
        showFailToast(i18n.t('earncash.earncash_fail'))
    }
}

// 轮询查询提现订单详情
const pollWithdrawDetail = async (orderId: string) => {
    const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

    // 首次尝试：1秒后
    await delay(1000)
    if (await intoWithdrawDetail(orderId)) {
        return
    }

    // 第二次尝试：再过1秒
    await delay(1000)
    if (await intoWithdrawDetail(orderId)) {
        return
    }

    // 第三次尝试：再过1秒
    await delay(1000)
    await intoWithdrawDetail(orderId) // 最后一次尝试，不再关心结果
}

// 展示提现订单详情
const intoWithdrawDetail = async (orderId?: string | null): Promise<boolean> => {
    if (!orderId) {
        return false
    }
    try {
        let res = await queryOrderDetails(QueryOrderParamsEvent.PAYOUT, orderId, false)
        // 2. 返回数据整理
        if (res.success && res.content && res.content.length > 0) {
            // 3. 输出详情统一数据 TransactionDetail
            let detailData = convertWithdrawDataToDetail(res.content)

            // 4. 如果成功获取详情数据，跳转到详情页
            if (detailData) {
                router.push({
                    name: 'transactionDetailInfo',
                    params: {
                        id: detailData.id,
                    },
                    query: {
                        data: JSON.stringify(detailData),
                    },
                })
                return true // 获取成功
            }
        }
    } catch (error) {
        console.error('Query withdraw details failed:', error)
    }
    return false // 获取失败或数据为空
}
const handleConfirm = () => {
    state.digit = ''
}

const getAccountInfo = async (loading = true) => {
    try {
        const res = await api.getAccountInfo(loading)
        if (res.code === 200) {
            state.accountInfo = res.data
        }
    } catch (e) {
        console.log(e)
    }
}
const getEarnPayOutInfos = async () => {
    try {
        const res = await api.getEarnPayOutInfo()
        if (res.code === 200) {
            state.conditon = res.conditon
            // state.isAuto = res.isAuto
            state.channels = res.channels
        }
    } catch (e) {
        console.log(e)
    }
}
getEarnPayOutInfos()
</script>
<style scoped lang="scss">
.common-content {
    @apply flex flex-col;

    .info {
        margin-bottom: 11px;
        height: 216px;
        border-radius: 15px;
        background-color: #333738;

        .top {
            @apply flex;
            padding: 25px 35px 0;
            .balance {
                @apply flex items-center gap-[10px];
                flex: 1;
                color: #fff;
                // text-align: center;
                font-size: 30px;
                font-weight: 400;

                &::before {
                    display: inline-block;
                    content: '';
                    width: 40px;
                    height: 40px;
                    background: url('@/assets/img/earn-cash/earn_gold.png') no-repeat;
                    background-size: 100% 100%;
                }

                :deep(span) {
                    color: #ffea76;
                }
            }
            .record {
                @apply flex justify-center items-center gap-[5px];
                padding: 5px 15px;
                border-radius: 15px;
                border: 3px solid #394143;
                background-color: #2a2d2e;
                color: #fff;
                font-size: 24px;
                font-weight: 400;

                .anticon {
                    font-size: 30px;
                    color: #8eaaba;
                }

                .right {
                    position: relative;
                    @apply flex justify-center items-center;
                    width: 29px;
                    height: 29px;
                    background: #8eaaba;
                    border-radius: 50%;
                    color: #000;
                    font-size: 20px;
                }
            }
        }
        .withdraw {
            @apply flex  items-center;
            margin: 34px auto 11px;
            width: 640px;
            height: 77px;
            padding: 0 26px;
            border: 1px solid #9e9e9a;
            background-color: #2a2d2e;
            border-radius: 15px;
            color: #ffea76;
            font-size: 48px;
            font-weight: 600;

            &::before {
                margin-right: 10px;
                display: inline-block;
                content: '';
                width: 40px;
                height: 40px;
                background: url('@/assets/img/earn-cash/earn_gold.png') no-repeat;
                background-size: 100% 100%;
            }
        }
        .withdraw-tip {
            color: #67717e;
            text-align: center;
            font-size: 24px;
            font-weight: 400;
        }
    }
    .content {
        flex: 1;
        padding: 0 30px;
        overflow-y: auto;
        border-radius: 15px;
        background-color: #333738;

        .payout-method {
            padding: 30px 0;
            .method-card {
                position: relative;
                margin: 20px auto 0;
                width: 100%;
                padding: 0 70px 0 20px;
                border-radius: 10px;
                background: linear-gradient(90deg, #027757 0, #00953a);
                display: flex;
                flex-direction: column;
                .method-card-content {
                    display: flex;
                    align-items: center;
                    // justify-content: space-between;
                    min-height: 88px;
                    gap: 20px;
                    .binded-item:only-child {
                        max-width: 90%; // 单个item时可以占用更多空间
                    }
                    .binded-item:nth-child(1):not(:only-child) {
                        max-width: 45%; // 多个item时限制左侧item的最大宽度
                    }
                    .binded-item:nth-child(2) {
                        margin-left: auto;
                        max-width: 50%; // 限制右侧item的最大宽度
                    }
                    .binded-item {
                        display: flex;
                        font-size: 22px;
                        font-weight: bold;
                        color: #fefefebb;
                        flex-shrink: 0; // 防止item本身被挤压
                        // width: 100%;
                        // max-width: 300px;
                        .bind-name {
                            margin-right: 10px;
                            flex-shrink: 0;
                            // min-width: 250px;
                        }
                        .bind-text {
                            flex: 1;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;

                            .icon {
                                display: inline-block;
                                // width: 19px;
                                // height: 19px;

                                &::after {
                                    display: inline-block;
                                    content: '';
                                    width: 36px;
                                    height: 24px;
                                    background: url('@/assets/img/wallets/hiden.png') no-repeat;
                                    background-size: 100% 100%;
                                }
                                &.active {
                                    &::after {
                                        background-image: url('@/assets/img/wallets/visible.png');
                                    }
                                }
                            }
                        }
                    }
                }

                .edit-btn {
                    position: absolute;
                    width: 70px;
                    height: 70px;
                    transform: translate(0, -50%);
                    right: 0%;
                    top: 50%;
                    &::after {
                        display: inline-block;
                        content: '';
                        width: 36px;
                        height: 36px;
                        background: url('@/assets/img/wallets/edit.png') no-repeat;
                        background-size: 100% 100%;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                    }
                }
                // .secret-btn {
                //     display: flex;
                //     justify-content: flex-end;
                //     align-items: flex-end;
                //     position: absolute;
                //     right: 10px;
                //     top: 10px;
                //     width: 40px;
                //     height: 40px;

                //     &::after {
                //         display: inline-block;
                //         content: '';
                //         width: 36px;
                //         height: 24px;
                //         background: url('@/assets/img/wallets/hiden.png') no-repeat;
                //         background-size: 100% 100%;
                //     }
                //     &.active {
                //         &::after {
                //             background-image: url('@/assets/img/wallets/visible.png');
                //         }
                //     }
                // }
            }
            .bind-account {
                text-align: center;
                margin-top: 20px;
                div {
                    margin: 0 auto;
                    display: inline-block;
                    position: relative;
                    font-size: 36px;
                    color: #ffea77;
                    text-align: center;

                    &::before,
                    &::after {
                        display: inline-block;
                        content: '';
                    }
                    &::after {
                        position: relative;
                        top: 3px;
                        margin-left: 7px;
                        width: 32px;
                        height: 32px;
                        border-radius: 50%;
                        background: url('@/assets/img/wallets/y-row.png') no-repeat;
                        background-size: 100% 100%;
                    }
                    &::before {
                        flex-grow: 0;
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        width: 100%;
                        height: 5px;
                        background-color: #ffea77;
                        border-radius: 2px;
                    }
                }
            }
        }
        .withdraw-title {
            margin-bottom: 34px;
            font-size: 30px;
            line-height: 30px;
            letter-spacing: -1px;
            color: #ffffff;
        }
        :deep(.van-cell) {
            margin-bottom: 15px;
            padding-bottom: 30px;
            padding: 15px 30px;
            height: 77px;
            border: 3px solid #394143;
            background-color: #2a2d2e;
            border-radius: 15px;

            &::after {
                display: none;
            }
            .van-van-field__body,
            .van-field__control {
                height: 47px;
            }
            .van-field__control {
                color: #fff;
                font-size: 24px;
                font-weight: 400;

                &::placeholder {
                    color: #7b8491;
                }
            }
        }
        .money-pay {
            @apply flex items-center gap-[10px];
            margin-bottom: 13px;
            color: #fff;
            font-size: 28px;
            font-weight: 400;
            :deep(span) {
                color: #36ff62;
            }
            .icon {
                display: inline-block;
                width: 40px;
                height: 40px;
                background: url('@/assets/img/earn-cash/earn_gold.png') no-repeat;
                background-size: 100% 100%;
            }
        }
        .tip {
            color: #67717e;
            font-size: 24px;
            font-weight: 400;
            line-height: 36px;
        }
        .check-tip {
            position: absolute;
            bottom: -100px;
            min-height: 120px;
            padding: 27px 72px;
            font-size: 24px;
            line-height: 40px;
            color: #fefeff;
            background: url('@/assets/img/wallets/rate_tip.png') no-repeat;
            background-size: 100% 100%;

            :deep(.text-red-600) {
                color: #ffea77;
            }
        }
    }
    .wallet-btn {
        @apply flex flex-col  box-border h-[201px] pt-[36px];
        .btn {
            @apply flex justify-center items-center;
            min-width: 521px;
            padding: 0 30px;
            height: 97px;
            border-radius: 14px;
            background: linear-gradient(90deg, #2aee88 0%, #9ae871 100%), linear-gradient(#8b0500, #8b0500);
            box-shadow: 0 0 0.16rem rgba(35, 238, 136, 0.3), inset 0 -0.05333rem #1dca6a;
            color: #000;
            font-size: 44px;
            font-weight: 400;
        }
        .pay-tip {
            color: #ffea76;
            text-align: center;
            font-size: 28px;
            font-weight: 400;
        }
    }
    .wallet-btn.disabled {
        pointer-events: none;
        opacity: 0.7;
    }
}
.common-pop {
    height: 1130px;
    :deep(.home-server) {
        bottom: 40px;
    }

    .common-content {
        @apply flex-1 overflow-y-auto px-[35px];
    }
}
</style>
